// ============================================================================
// HINDI TRANSLATIONS - BIBLE VERSES
// ============================================================================
// प्रेरणादायक पदों का संग्रह स्ट्रॉन्ग संदर्भों के साथ

export const bibleVerses = [
  {
    reference: "फिलिप्पियों 4:13",
    text: "जो मुझे सामर्थ देता है, उसमें मैं सब कुछ कर सकता हूँ",
    version: "hindi_bible",
    theme: "शक्ति",
    strongNumbers: {
      "सकता": "G1411", // δύναμις (dynamis) = शक्ति, सामर्थ्य
      "सामर्थ": "G1743" // ἐνδυναμόω (endynamoo) = बल देना
    },
    context: "पौलुस मसीह के कारण सभी परिस्थितियों का सामना करने की अपनी क्षमता के बारे में बात करते हैं"
  },
  {
    reference: "भजन संहिता 23:1",
    text: "यहोवा मेरा चरवाहा है; मुझे किसी वस्तु की घटी न होगी",
    version: "hindi_bible",
    theme: "सुरक्षा",
    strongNumbers: {
      "चरवाहा": "H7462", // רָעָה (ra'ah) = चराना, रखवाली करना
      "घटी": "H2637" // חָסֵר (chaser) = कमी होना, आवश्यकता होना
    },
    context: "दाऊद दैवीय प्रावधान में अपने पूर्ण विश्वास को व्यक्त करता है"
  },
  {
    reference: "यूहन्ना 3:16",
    text: "क्योंकि परमेश्वर ने जगत से ऐसा प्रेम रखा कि उसने अपना एकलौता पुत्र दे दिया",
    version: "hindi_bible",
    theme: "प्रेम",
    strongNumbers: {
      "प्रेम": "G25", // ἀγαπάω (agapao) = बिना शर्त प्यार करना
      "दे_दिया": "G1325" // δίδωμι (didomi) = देना, भेंट करना
    },
    context: "मानवता के लिए परमेश्वर के प्रेम पर सबसे प्रसिद्ध पद"
  },
  {
    reference: "फिलिप्पियों 4:7",
    text: "तब परमेश्वर की शांति, जो समझ से बिल्कुल परे है, तुम्हारे हृदय को सुरक्षित रखेगी",
    version: "hindi_bible",
    theme: "शांति",
    strongNumbers: {
      "शांति": "G1515", // εἰρήνη (eirene) = शांति, सामंजस्य
      "सुरक्षित": "G5432" // φρουρέω (phroureo) = रक्षा करना, सुरक्षित रखना
    },
    context: "आंतरिक शांति के माध्यम से दैवीय सुरक्षा का वादा"
  },
  {
    reference: "भजन संहिता 119:105",
    text: "तेरा वचन मेरे पांव के लिये दीपक, और मेरे मार्ग के लिये उजियाला है",
    version: "hindi_bible",
    theme: "मार्गदर्शन",
    strongNumbers: {
      "दीपक": "H5216", // נִיר (niyr) = दीपक, प्रकाश
      "उजियाला": "H216" // אוֹר (or) = प्रकाश, रोशनी
    },
    context: "दैनिक जीवन में मार्गदर्शक के रूप में परमेश्वर का वचन"
  },
  {
    reference: "नीतिवचन 3:5-6",
    text: "तू अपने सारे मन से यहोवा पर भरोसा रख, और अपनी समझ का सहारा न लेना",
    version: "hindi_bible",
    theme: "विश्वास",
    strongNumbers: {
      "भरोसा": "H982", // בָּטַח (batach) = विश्वास रखना
      "मन": "H3820" // לֵב (leb) = हृदय, आत्मा, इच्छा
    },
    context: "अपनी स्वयं की क्षमताओं के बजाय परमेश्वर पर भरोसा करने का निमंत्रण"
  },
  {
    reference: "मत्ती 5:14",
    text: "तुम जगत की ज्योति हो; जो नगर पहाड़ पर बसा हो वह छिप नहीं सकता",
    version: "hindi_bible",
    theme: "गवाही",
    strongNumbers: {
      "ज्योति": "G5457", // φῶς (phos) = प्रकाश, आध्यात्मिक रोशनी
      "जगत": "G2889" // κόσμος (kosmos) = संसार, ब्रह्मांड
    },
    context: "यीशु अपने शिष्यों को संसार में गवाह बनने के लिए प्रोत्साहित करते हैं"
  }
];

export default bibleVerses;
